import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Form, Input} from 'antd';
import {modal} from 'icsoc-antd-ex';
import moment from 'moment';
import exportTasksActions from 'Actions/systemSetting/exportTasks';

const {ModalSize} = modal;
const FormItem = Form.Item;
const formItemLayout = {labelCol: {span: 5}, wrapperCol: {span: 19}};

class ReloadModal extends Component {
  // 点击确定
  handleSubmit = () => {
    const {
      setReloadModalVisible,
      exportTask,
      form: {validateFields},
    } = this.props;
    validateFields((err, values) => {
      if (!err) {
        const {taskName} = values || {};
        exportTask(taskName);
        setReloadModalVisible();
      }
    });
  };

  // 校验任务名称
  checkTaskName = (rule, value, callback) => {
    const valueTrim = (value && value.replace(/^\s+|\s+$/g, '')) || '';

    if (valueTrim !== '') {
      if (!/^[a-zA-Z0-9_\u4e00-\u9fa5]{1,500}$/g.test(valueTrim)) {
        callback('任务名称只能由数字、字母、汉字和下划线组成！');
      }
    }
    callback();
  };

  render() {
    const {
      setReloadModalVisible,
      form: {getFieldDecorator},
      reloadModalData,
      pageType,
    } = this.props;
    const timeStr =
      moment()
        .format('YYYY-MM-DD')
        .toString()
        .replace(/-/g, '') + moment().valueOf();

    return (
      <ModalSize
        title="新建导出任务"
        centered
        maskClosable={false}
        visible
        onOk={this.handleSubmit}
        onCancel={setReloadModalVisible}>
        <Form>
          <FormItem {...formItemLayout} label="任务名称">
            {getFieldDecorator('taskName', {
              initialValue:
                pageType === 'detail'
                  ? `任务详情导出${timeStr}`
                  : pageType === 'statistic'
                    ? `任务统计导出${timeStr}`
                    : pageType === 'questionNaire'
                      ? `问卷导出${timeStr}`
                      : reloadModalData.taskName,
              rules: [
                {
                  validator: this.checkTaskName,
                },
                {
                  required: true,
                  whitespace: true,
                  message: '任务名称不能为空！',
                },
              ],
            })(<Input placeholder="请输入任务名称" />)}
          </FormItem>
        </Form>
      </ModalSize>
    );
  }
}

const mapStateToProps = ({systemSettingExportTasks}) => ({
  reloadModalData: systemSettingExportTasks.reloadModalData,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(exportTasksActions, dispatch),
});
const ReloadModalWrap = Form.create()(ReloadModal);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReloadModalWrap);
